import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { saSignalingConnectionChartConfig } from '../chartConfigs';

interface SignalingConnectionSaEchartsProps {
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const SignalingConnectionSaEcharts: React.FC<SignalingConnectionSaEchartsProps> = ({ onFullscreenToggle, isFullscreen }) => (
  <SiteCharts config={saSignalingConnectionChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} />
);

export default SignalingConnectionSaEcharts;
